
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';

import { getImage, getData } from '../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import { useRefresh } from '../../hooks/useRefresh';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import DetailProduct from './DetailProduct';


function Index({dishMenu, setShowDetailProduct, setShowListProduct2}) { 

      const {i18n} = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
  
      const { dish, alldish } = dishMenu;
     const [showDetailProduct2, setShowDetailProduct2] = useState(false);
      const [dataDish, setDataDish] = useState(dish);
      const [dataDesserts, setDataDesserts] = useState(false);
      const [dataDrinks, setDataDrinks] = useState(false);
    
    const [isImageLoading, setIsImageLoading] = useState(true); 
    const [isImageLoadingOne, setIsImageLoadingOne] = useState(true); 
    const [isImageLoadingTwo, setIsImageLoadingTwo] = useState(true); 
    const [dataFood, setDataFood] = useState(false);

    const [image, setImage] = useState(false);
     const [imageOne, setImageOne] = useState(false);
        const [imageTwo, setImageTwo] = useState(false);
    
        const [showListProduct, setShowListProduct] = useState(false);
        const [dishs, setdishs] = useState(false);
  
      const {change} = useRefresh();
        const [menus, setMenus] = useState([]);
    
    const [flavors, setFlavors] = useState(dish.flavors);
    
    const [showSpecials, setShowSpecials] = useState(false);
     const [grill, setGrill] = useState(false);
    
    useEffect(() => {
        setFlavors(dataDish.flavors);
    }, [dataDish]);
    
      useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
              setMenus(data);
          });
      }, [change]);
      
      
    useEffect(() => {
        setIsImageLoading(true);
        setIsImageLoadingOne(true);
        setIsImageLoadingTwo(true);
          fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
              if (url) {
                  setImage(url);
                  setIsImageLoading(false); 
              }
          });

           fetchImage(`menu-image-one-${dataDish.id}`).then(async (url) => {
               if (url) {
                   const isValid = await isValidImage(url);
                   if (isValid) {
                       setImageOne(url);
                        setIsImageLoadingOne(false);
                    }
                }    
            }); 

        fetchImage(`menu-image-two-${dataDish.id}`).then(async (url) => {
            if (url) {
                const isValid = await isValidImage(url);
                if (isValid) {
                    setImageTwo(url);
                     setIsImageLoadingTwo(false);
                }
                
            }
        });
  
      }, [dataDish]);
      
    
    const isValidImage =(url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true); // La imagen se cargó correctamente
                img.onerror = () => resolve(false); // La imagen está rota o no se puede cargar
                img.src = url; // Inicia la carga de la imagen
            });
        }
  
       useEffect(() => {
          menus.map((item) => {
              if (item.id === 252) {
              setDataDesserts(item);
              }
              if (item.id === 257) {
                setDataFood(item.menus);
            }
         
          });
       }, [menus]);
    
    
        useEffect(() => {
        if (dataFood) {
            dataFood.map((item) => {
                if (item.id === 5197) {
                    setGrill(item);
                }
                
            });
        }
        }, [dataFood]);
    
  
  
      const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
  
    const navDish = (position) => {
          if(alldish.length > 0){
          const menuIndex = alldish.findIndex(item => item === dataDish);
  
          let newIndex;
          if (position === 1) {
          newIndex = (menuIndex + 1) % alldish.length;
          } else if (position === -1) {
          newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
          } else {
          return;
          }
          const newDish = alldish[newIndex];
          setDataDish(newDish);
      }
      };
    
    return (
        <div style={{position: 'absolute', top: 5, left: 0, width: '100%', height: '100%', zIndex: 999}}>
            <LayoutContent showsocial={false} showLogo={true} setShowListProduct={setShowDetailProduct} showFooter={true} setShowSpecials={setShowSpecials} goHome={setShowListProduct2}>
                

                {alldish.length > 0 &&
                    <>
                <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '27%',
                        left: 20,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                            backgroundColor: '#000',
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(-1),
                      
                        ]}>
                        <img
                            style={{width: 30, height: 30, objectFit: 'contain', marginTop: 5}}
                            src={require('./assets/right.png')}
                        />
                    </div>
                </div>

                 <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '27%',
                        right: 20,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                            backgroundColor: '#000',
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(1),
                      
                        ]}>
                        <img
                            style={{width: 30, height: 30, objectFit: 'contain',  marginTop: 5}}
                            src={require('./assets/left.png')}
                        />
                    </div>
                </div>
                    </>
                }
                


                <div style={{overflow:'scroll', height: 900,  opacity: isImageLoading ? 0 : 1, 
                                    transition: "opacity 0.5s ease-in-out", }}>
                    <div style={{ padding: '10px 20px' }}>
                        <div style={{ minHeight: 350}}>
                            <img
                                src={image}
                                alt="Dynamic content"
                                style={{
                                    width: "100%",
                                    height: 350,
                                    objectFit: "cover",
                                    opacity: isImageLoading ? 0 : 1, 
                                    transition: "opacity 0.5s ease-in-out", 
                                }}
                                onLoad={() => setIsImageLoading(false)} 
                                />
                        <br />

                        

                        {imageOne && (
                            <>
                            <div
                                        style={{
                                        display: "flex",
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    marginTop: 20,
                                    }}>
                                    <div
                                    onPress={() => {}}
                                    style={{
                                        width: 320,
                                        height: 195,

                                        position: 'relative',
                                        
                                    }}>
                                    <img
                                        src={imageOne}
                                        style={{
                                        width: '100%',
                                        height: 195,
                                        objectFit: 'cover',
                                        borderRadius: 20,
                                            position: 'relative',
                                            opacity: isImageLoadingOne ? 0 : 1, 
                                            transition: "opacity 0.5s ease-in-out", 
                                    
                                        
                                        }}
                                             onLoad={() => setIsImageLoadingOne(false)} 
                                    
                                    />
                                    </div>

                                    <div
                                    onPress={() => {}}
                                    style={{
                                        width: 320,
                                        height: 195,
                                        position: 'relative',
                                        
                                    }}>
                                    <img
                                        src={imageTwo}
                                        style={{
                                        width: '100%',
                                        height: 195,
                                        objectFit: 'cover',
                                        borderRadius: 20,
                                            position: 'relative',
                                        opacity: isImageLoadingTwo ? 0 : 1, 
                                            transition: "opacity 0.5s ease-in-out",
                                        
                                        }}
                                             onLoad={() => setIsImageLoadingOne(false)} 
                                    />
                                    </div>
                                </div>
                            </>
                        )}
                        </div>
                        
                        <div>
                            <center>
                                <img src={require('./assets/detail.png')} style={{width: 500, height: 50, objectFit: 'contain', pointerEvents: 'none'}} />
                            </center>
                        </div>

                        <div style={{
                            marginTop: 10,
                           
                            backgroundColor: 'black',
                            borderRadius: 20,
                            border: "1px solid #2e2e2e",
                            
                        }}>
                               

                                    <div style={{
                                        fontFamily: "Poltawski",
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                    width: '100%',
                                        padding: 20,
                                background: 'linear-gradient(180deg, rgba(15,15,15,0.95) 0%, rgba(190,157,60,0.85) 100%)',
                                borderTopLeftRadius: 20,
                                borderTopRightRadius: 20,
                                        boxSizing: 'border-box',
                                    }}>
                                        <p  style={{fontSize: 32, color: 'white', textAlign: 'left'}}>
                                        {langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}
                                </p>
                                
                                 <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                    margin: '0px 10px',
                                        gap: 10
                                    }}>
                                        <p
                                            style={{ fontSize: 24, color: '#fff', fontWeight: 'bold',  fontFamily: "Poltawski", }}>
                                            
                                    {dataDish.price > 0
                                                        ? ` ${dataDish.label_price ?? ''} ${
                                                            dataDish.price
                                                        }`
                                                        : 'Market Price'}
                                        </p>
                                    </div>
                                    </div>

                                   
                              
                                
                                <div style={{padding: 20, boxSizing: 'border-box'}}>
                                    <p
                                        lineBreakMode="tail"
                                        className='shor-text'
                                
                                    style={{fontSize: 22, textAlign:'left', color: '#9b9b9b', fontFamily: "LondrinaSolidLight",}}>
                                    {dataDish.regular_decription.replace(/\\n/g,'\n')
                                        }
                                        
                                        
                                    </p>
                            </div>
                            

                        {flavors.length > 0 && (
                        <div
                                    style={{
                                display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            flexWrap: 'wrap',
                            marginTop: 10,
                            }}>
                            {flavors.map((item, key) => {
                            return (
                                <div
                                key={key}
                                style={{
                                    backgroundColor: 'black',
                                    width: '29%',
                                    marginHorizontal: 1,
                                    margin: '1px 1px',
                                    borderRadius: 10,
                                    padding: 10,
                                    
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    position: 'relative',
                                    
                                }}>
                                    <div style={{width: '70%'}}>
                                        <p
                                      
                                            style={{
                                            width: '100%',
                                            color: 'white',
                                            fontSize: 11,
                                            textTransform: 'uppercase',
                                          
                                        }}>
                                            {item.name}
                                    </p>
                                    </div>

                                    <div style={{width: '15%'}}>
                                {item.price > 0 ? (
                                    <p
                                    className='shor-text'
                                    style={{
                                        color: 'white',
                                       
                                    }}>
                                    {item.price}
                                    </p>
                                ) : (
                                    <p
                                    style={{
                                        color: 'white',
                                        fontSize: 9,
                                        position: 'absolute',
                                        right: 10,
                                        bottom: 10,
                                    }}>
                                    Market Price
                                    </p>
                                        )}
                                        
                                    </div>
                                </div>
                            );
                            })}
                        </div>
                        )}
                            
                        </div>
                        
                    </div>
                    

                    
                </div>
            </LayoutContent>

            {showDetailProduct2 && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowDetailProduct2}
                    setShowDetailProduct={setShowDetailProduct2}
            />}
            
             {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
                goHome={setShowListProduct2}
            />}

             {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowListProduct2}/>}
        </div>
    );
}
export default Index;